<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">审批处置公告</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <query-tabs
          :query-tabs="queryTabs"
          :active.sync="activeName"
        ></query-tabs>
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheckBidFile(scope.row)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:planCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  class="cell-link"
                  @click="onCheckBidDetail(scope.row.planId)"
                  >{{ scope.row.planCode }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:statusCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.statusCode == 1
                    ? '待审核'
                    : scope.row.statusCode == 2
                    ? '审批中'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operations="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  @click="modify(scope.row)"
                  class="cellbutton text"
                  v-if="activeName == 1"
                  >审批</span
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
  </div>
</template>
<script>
import { daterange, openNewPage } from '@/utils/constantime'
export default {
  data() {
    return {
      removeV: 1,
      pageNum: 1,
      pageSize: 10,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      formConfig: {
        configs: {},
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      queryTabs: [
        {
          label: 1,
          name: '待审批'
        },
        {
          label: 2,
          name: '已审批'
        }
      ],
      activeName: 1,
      //未发布
      preorganizationFormConfig: {
        code: {
          tag: 'input',

          label: '公告编号'
        },
        title: {
          tag: 'input',
          label: '公告标题'
        },
        createPerson: {
          tag: 'input',
          label: '经办人'
        },
        submitTime: {
          ...daterange,
          label: '提交日期'
        }
      },
      // 竞买中
      prependingFormConfig: {
        code: {
          tag: 'input',
          label: '公告编号'
        },
        title: {
          tag: 'input',
          label: '公告标题'
        },
        createPerson: {
          tag: 'input',
          label: '经办人'
        },
        submitTime: {
          ...daterange,
          label: '提交时间'
        }
      },
      // 默认表格配置
      tableConfig: {
        isPagination: true,
        columns: [],
        data: [],
        total: 0
      },
      // 待审批
      preorganizationTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center'
        },
        {
          prop: 'code',
          label: '公告编号',
          // width: '100px',
          'show-overflow-tooltip': true
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          'show-overflow-tooltip': true
        },
        {
          slot: 'planCode',
          prop: 'planCode',
          label: '委托编号',
          'show-overflow-tooltip': true
        },
        {
          prop: 'submitTime',
          label: '提交时间',
          align: 'center',
          width: '150px'
        },

        {
          prop: 'createPerson',
          label: '经办人',
          align: 'center',
          width: '80px'
        },
        {
          slot: 'statusCode',
          prop: 'statusCode',
          'show-overflow-tooltip': true,
          label: '状态',
          align: 'center'
        },
        {
          slot: 'operations',
          prop: 'operations',
          label: '操作',
          width: '60px',
          align: 'center',
          fixed: 'right'
        }
      ],
      //已审批
      prependingTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center'
        },
        {
          prop: 'code',
          label: '公告编号',
          // width: '100px',
          'show-overflow-tooltip': true
        },
        {
          slot: 'title',
          prop: 'title',
          label: '公告标题',
          'show-overflow-tooltip': true
        },
        {
          slot: 'planCode',
          prop: 'planCode',
          label: '委托编号',
          'show-overflow-tooltip': true
        },
        {
          prop: 'submitTime',
          label: '提交时间',
          align: 'center',
          width: '150px'
        },

        {
          prop: 'createPerson',
          label: '经办人',
          align: 'center',
          width: '80px'
        },
        {
          prop: 'scheduleView',
          label: '处置进度',
          align: 'center'
          // width: '90px'
        }
      ]
    }
  },
  watch: {
    activeName: {
      handler: function(val) {
        this.activeName = val
        this.params = {
          pageIndex: this.pageNum,
          pageSize: this.pageSize
        }

        this.onChoose(val)
      },
      immediate: true
    }
  },
  methods: {
    remove(val) {
      this.removeV = val
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.onChoose(this.activeName)
    },
    onSizeChange(val) {
      this.params = {
        pageIndex: 1,
        pageSize: val
      }
      this.onChoose(this.activeName)
    },
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        pagetype: 2
      }
      openNewPage('ServiceCompileMaterialCheck', query)
    },
    onChoose(val) {
      if (val === 1) {
        this.planListTodo(5)
      } else if (val === 2) {
        this.planListTodo(6)
      }
    },
    async planListTodo(type) {
      let obj = {
        ...this.params,
        tag: type
      }
      let data = await this.$api.serviceProvider.listAudit(obj)
      this.tableConfig.data = data.data
      if (type == 5) {
        this.formConfig.configs = this.preorganizationFormConfig
        this.tableConfig.columns = this.preorganizationTableColumns
      } else {
        this.formConfig.configs = this.prependingFormConfig
        this.tableConfig.columns = this.prependingTableColumns
      }

      this.tableConfig.total = data.total
    },
    async listTodo() {
      // let obj = {
      //   ...this.params,
      //   dateSelect: null,
      //   startTime: this.params.dateSelect ? this.params.dateSelect[0] : null,
      //   endTime: this.params.dateSelect ? this.params.dateSelect[1] : null
      // }
      let obj = {
        ...this.params,
        tag: 6
      }
      let data = await this.$api.materialdisposal.listAudit(obj)
      this.tableConfig.data = data.data
      this.formConfig.configs = this.prependingFormConfig
      this.tableConfig.columns = this.prependingTableColumns
      this.tableConfig.total = data.total
    },
    onCheckBidDetail(planId) {
      let query = {
        id: planId
      }
      openNewPage('ParticularsDetail', query)
    },
    onQuery(val) {
      let submitTimeStart = null
      let submitTimeEnd = null
      if (val.submitTime) {
        submitTimeStart = val.submitTime[0]
        submitTimeEnd = val.submitTime[1]
      }
      this.params = {
        ...val,
        submitTimeStart: submitTimeStart,
        submitTimeEnd: submitTimeEnd,
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        submitTime: null
      }
      this.onChoose(this.activeName)
    },
    onReset() {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.onChoose(this.activeName)
    },
    //修改
    modify(o) {
      let query = {
        id: o.id,
        pagetype: 1
      }
      this.$router.push({ name: 'ServiceCompileMaterialCheck', query })

      // openNewPage('CompileMaterialupdata', query)
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 8px;
}
</style>
